export const siteConfig = {
  name: "Massageterapi CPH",
  owner: "Trine Agerbo",
  title: "Massage og massageterapi Nørrebro",
  description: "Professionel massageterapi med en holistisk tilgang. Jeg arbejder med at styrke kroppens egne helingsprocesser ved påvirkning af muskler, bindevæv og nervesystem.",
  email: "trine@massageterapicph.dk",
  phone: "+45 31 19 87 50",
  address: "Ryesgade 27, Baghuset 1. sal, 2200 København N",
  cvr: "42081833",
  bookingUrl: "https://massageterapitrine-agerbo.planway.com/",
  socials: {
    facebook: "https://facebook.com/massageterapicph",
    instagram: "https://instagram.com/massageterapicph"
  },
  images: {
    hero: "/imgi_3_Klinikplanteplakat.jpg",
    clinic: "/kundebilleder/imgi_5_Mellembriksogbord.jpg",
    portrait: "/kundebilleder/imgi_13__DSC0647.jpg"
  }
};

export const services = [
  {
    id: "integrativ-massageterapi",
    title: "Integrativ Massageterapi",
    shortDescription: "Integrativ massageterapi er en holistisk massageform der tager udgangspunkt i dine aktuelle udfordringer, men behandler med inddragelse af hele kroppen; muskler, led, bindevæv og nervesystem. Målet er at flytte fokus fra symptombehandling til de bagvedliggende spændingsmønstre og strukturer, der er kilde til dine udfordringer eller smerter.",
    fullDescription: `Integrativ massageterapi er en holistisk massageform der tager udgangspunkt i dine aktuelle udfordringer, men behandler med inddragelse af hele kroppen; muskler, led, bindevæv og nervesystem. Målet er at flytte fokus fra symptombehandling til de bagvedliggende spændingsmønstre og strukturer, der er kilde til dine udfordringer eller smerter.

Jeg tilbyder et bredt udvalg af teknikker, herunder fysiurgisk massage, bindevævsterapi og funktionelle teknikker. Mine behandlinger er designet til at lindre en række symptomer som skader i det bløde væv, hovedpine, stress, nakkesmerter, hold i ryggen og iskiassmerter.

Med en holistisk tilgang arbejder jeg med at styrke kroppens egne helingsprocesser ved påvirkning af muskler, bindevæv og nervesystem. Behandlingen stimulerer desuden lymfesystem og kredsløb, hvilket understøtter kroppens evne til at udskille affaldsstoffer og optimere restitution. Massageterapi er en præcis dialog mellem dine væv og din funktion – uanset om du søger lindring, styrke eller frihed i bevægelse.`,
    duration: ["30 minutter", "60 minutter", "90 minutter"],
    prices: ["495 kr.", "795 kr.", "1.095 kr."],
    image: "/kundebilleder/imgi_17__DSC0587.jpg",
    benefits: [
      "Nakke- og rygsmerter",
      "Smertelindring",
      "Lindring af skader i blødt væv",
      "Afhjælpning af hovedpine, migræne og stress",
      "Fibromyalgi",
      "Gravidmassage",
      "Forbedring af vejrtrækning",
      "Forbedring af kropsholdning",
      "Styrkelse af kroppens naturlige helingsprocesser",
      "Stimulering af lymfesystem og kredsløb",
      "Øget bevægelsesfrihed og lethed"
    ]
  }
];

export const aboutTrine = {
  name: "Trine Agerbo",
  title: "Massageterapeut (RAB)",
  image: "/kundebilleder/imgi_4_Ude.jpg",
  bio: `Som menneske er jeg fokuseret på at styrke sammenhængen mellem krop og sind, og mine behandlinger afspejler denne forbindelse. Jeg arbejder grundigt, men nænsomt med dine behov, altid med udgangspunkt i din aktuelle tilstand.

Din krop er et levende arkiv. Hver muskel, hvert led og hver nervefiber bærer på spor af dine vaner, dine bevægelser og dine daglige oplevelser. Når vi arbejder med kroppen, arbejder vi ikke kun med dens struktur – vi arbejder med dens måde at bære og bevæge sig på. Og dens kapacitet til at helbrede og udvikle sig.

Jeg inviterer dig til at opleve, hvordan en behandling hos mig kan skabe lethed og bevægelsesfrihed i din krop.`,
  rabExplanation: "RAB er en beskyttet titel, der kun må bruges af behandlere, der lever op til lovgivningens krav om uddannelse, etik og god klinisk praksis. Det er din garanti for en professionel behandling af høj kvalitet. Mange private sundhedsforsikringer dækker eller giver tilskud til mine behandlinger."
};

export const testimonials = [
  {
    name: "Mette S.",
    text: "Trine har en helt særlig evne til at mærke præcis, hvor spændingerne sidder. Jeg går altid derfra med en følelse af lethed i både krop og hoved.",
    location: "København N"
  },
  {
    name: "Thomas P.",
    text: "Den mest nærværende behandling jeg har fået. Der er en ro og en faglighed, som gør, at man føler sig i meget trygge hænder.",
    location: "Østerbro"
  },
  {
    name: "Sofie L.",
    text: "Efter et forløb hos Trine er mine nakkespændinger og stressniveau faldet mærkbart. Kan varmt anbefales.",
    location: "Nørrebro"
  }
];

export const practicalInfo = {
  location: {
    title: "Her finder du klinikken",
    description: "Klinikken er placeret i IFIB (Institut for Integreret Behandling) i de rolige og lyse omgivelser i baghuset på Ryesgade 27.",
    address: siteConfig.address,
    access: "Der er adgang via porten til baghuset. Klinikken ligger på 1. sal.",
    images: [
      "/kundebilleder/imgi_5_Mellembriksogbord.jpg",
      "/kundebilleder/imgi_4_Ude.jpg",
      "/kundebilleder/imgi_3_Klinikplanteplakat.jpg",
      "/kundebilleder/imgi_26_IMG20251012185805~4.jpg",
      "/kundebilleder/imgi_12_IMG20251012190732~4.jpg"
    ]
  },
  booking: {
    title: "Booking & Priser",
    description: "Du kan nemt booke din tid online via Planway. Har du spørgsmål inden din behandling, er du altid velkommen til at kontakte mig.",
    pricing: [
      { service: "Integrativ Massageterapi", duration: "(30 minutter)", price: "495 kr." },
      { service: "Integrativ Massageterapi", duration: "(60 minutter)", price: "795 kr." },
      { service: "Integrativ Massageterapi", duration: "(90 minutter)", price: "1.095 kr." }
    ]
  }
};
